export default "{{$ctrl.region_name}}<span ng-hide=\"$ctrl.country_code == 'US'\">, <country code=\"$ctrl.country_code\"></country></span>";